import React from 'react';
import ResendAction from './Actions/ResendAction';
import CancelAction from './Actions/CancelAction';
import RescheduledAction from './Actions/RescheduleAction';

import { Can } from '../../../../_contexts/AbilitiesContext';

export default function SentActions({ loadData, form }) {
  return <div>
    <Can I="send" a="form">
      <ResendAction loadData={loadData} form={form} /> &nbsp;
    </Can>
    
    <Can I="reschedule" a="form">
      <RescheduledAction form={form} /> &nbsp;
    </Can>

    <Can I="cancel" a="form">
      <CancelAction form={form} />
    </Can>
  </div>
}